<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Пазы</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="no-padding" fusePerfectScrollbar>
    <csl-slot-select
      [slots]="data.slots"
      [postCustomSlotsData]="data.postCustomSlotsData"
      [deleteCustomSlot]="data.deleteCustomSlot"
      [customSlotSchemas]="data.customSlotSchemas"
      [fullPanelThickness]="data.fullPanelThickness"
      [mapSchemaToSlot]="data.mapSchemaToSlot"
      (selectionChange)="selectionChanged($event.source.selected)"></csl-slot-select>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="m-0 p-4 flex justify-end items-center">
    <button
      data-testid="okSlotsButton"
      i18n
      mat-raised-button
      class="mat-accent mr-4"
      (click)="dialogRef.close(selected?.[0])"
      >ОК</button
    >
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
